import {h} from 'preact';
import {ProductImage} from './ProductImage';
import {CalculatorProduct} from '../types';
import {CounterWidget} from './CounterWidget';
import {useCalculatorContext} from '../context';
import {actions} from '../reducer';
import {sortVendorsByAlphabet} from '../../../utils';

type ProductProps = {
  item: CalculatorProduct;
  id: number;
}

function Product({item, id}: ProductProps) {
  const {image, image_width, image_height, name, price, initial, qty} = item;
  const {state: {serviceKits, currentKitIndex, currentVendorIndex}, dispatch} = useCalculatorContext();
  const sortedVendors = sortVendorsByAlphabet(serviceKits[currentKitIndex].vendors);
  const count = qty ? qty : initial;

  function incrementQty(product: CalculatorProduct) {
    const maxVal: number = product.max > 0 ? product.max : Infinity;
    // if (product?.qty > maxVal)  return; // FIXME: wrong branch condition
    const qty = (product?.qty > 0) ? product.qty : product.initial
    dispatch(actions.setProductsQty({productId: id, qty: qty + 1, productType: "equipment"}))
    dispatch(actions.setProductsSum( sortedVendors[currentVendorIndex].base_cost))
    dispatch(actions.setSetupSum())
  }

  function decrementQty(product: CalculatorProduct) {
    const minVal: number = product.min ? product.min : 0;
    if (product?.qty <= minVal)  return;
    const qty = (product?.qty > 0) ? product.qty : product.initial
    dispatch(actions.setProductsQty({productId: id, qty: qty - 1, productType: "equipment"}))
    dispatch(actions.setProductsSum( sortedVendors[currentVendorIndex].base_cost))
    dispatch(actions.setSetupSum())
  }

  function updateAmount(product: CalculatorProduct) {
    return (amountArg: number) => {
      const amount = +amountArg;
      const minVal: number = product.min ? product.min : 0;
      const maxVal: number = product.max > 0 ? product.max : Infinity;
      if (product.qty < minVal || product.qty > maxVal)  return;
      dispatch(actions.setProductsQty({productId: id, qty: amount, productType: "equipment"}))
      dispatch(actions.setProductsSum( sortedVendors[currentVendorIndex].base_cost))
      dispatch(actions.setSetupSum())
    }
  }

  return (
    <>
      <ProductImage imageUrl={image} width={image_width} height={image_height} />
      <div className="kits__table-row-item wide">{name}</div>
      <div className="kits__table-row-item">
        <span>{price}</span><span> руб.</span>
      </div>
      <CounterWidget 
        value={count}
        incrementQty={() => incrementQty(item)}
        decrementQty={() => decrementQty(item)}
        updateAmount={updateAmount(item)} 
      />
    </>
  )
}

export {Product};
